import React from 'react';

import c from 'classnames';
import { useDispatch } from 'react-redux';

import { CoreLink } from '../../../components';
import { hideNavMenu } from '../../../actions/UI';

import './style.scss';

const GenericNavigationMainMenuMobile = ({ items }) => {
  const dispatch = useDispatch();

  const handleItemClick = () => {
    dispatch(hideNavMenu());
  };

  return (
    <div className="GenericNavigationMainMenuMobile">
      <div className="GenericNavigationMainMenuMobile__items">
        {items.toJS().map((item) => {
          const href = item.link.url ?? '';
          const title = item.link.title ?? 'Untitled';
          const description = item.link.description ?? null;
          const classes = item.link?.options?.attributes?.class ?? [];

          const itemClass = c('GenericNavigationMainMenuMobile__title', ...classes);

          return (
            <CoreLink onClick={handleItemClick} to={href}>
              <li key={`menu--main--menu-item-${title}:${href}`} className="menu--main--menu-item">
                <div className={itemClass}>
                  <div className="GenericNavigationMainMenuMobile__title__inner">
                    {title}
                    <div className="GenericNavigationMainMenuMobile__items__arrow icon-after icon-arrow-right" />
                  </div>
                  {description && (
                    <div className="GenericNavigationMainMenuMobile__title__description">
                      {description}
                    </div>
                  )}
                </div>
              </li>
            </CoreLink>
          );
        })}
      </div>
    </div>
  );
};

export default GenericNavigationMainMenuMobile;
